import TableSmall from './table-small';

export default TableSmall;
